import CloseIcon from '@mui/icons-material/Close'
import {
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography
} from '@mui/material'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'
import AppButton from './AppButton'
import { useDefaultComponentTools } from '../hooks/useDefaultComponentTools'


const AppPopup = ({
	title,
	onAction,
	actionTitle,
	text,
	setOpenedComponent,
	children
}) => {
	const { theme, mdDown } = useDefaultComponentTools()
	const onClose = () => {
		setOpenedComponent(false)
	}
	const actionClick = () => {
		onAction()
		onClose()
	}

	return (
		<Dialog
			open={true}
			sx={{
				'.MuiDialog-paper':
				{
					background: theme.palette.mode === 'dark' ? theme.palette.third : theme.palette.background,
					minHeight: '224px',
					minWidth: mdDown ? '340px' : '460px',
					p: 3
				}
			}}
		>
			<IconButton
				aria-label='close'
				onClick={onClose}
				sx={{
					color: theme.palette.text.secondary,
					position: 'absolute',
					right: 8,
					top: 8
				}}
			>
				<CloseIcon/>
			</IconButton>
			<Box sx={{ border: 'none', padding: 1 }}>
				<DialogTitle sx={{color: theme.palette.text.primary}}>{title}</DialogTitle>
				{children ?
					children :
					<Box>
						<DialogContent >
							<Typography sx={{color: theme.palette.text.primary}} gutterBottom>{text}</Typography>
						</DialogContent>
						<AppButton
							onClick={actionClick}
							title={actionTitle}
							inputSx={{
								':hover': {background: theme.palette.red, opacity: 0.7},
								background: theme.palette.red, height: '56px',
								textTransform: 'capitalize', width: '100%'
							}}
						/>
					</Box>
				}
			</Box>
		</Dialog>
	)
}

AppPopup.propTypes = {
	actionTitle: PropTypes.string,
	children: PropTypes.node,
	onAction: PropTypes.func,
	setOpenedComponent: PropTypes.func,
	text: PropTypes.string,
	title: PropTypes.string
}

export default AppPopup
